export default {
  bio: "candidate/profile",
  update: "profile/update",
  marital: "setup/maritalStatus",
  titles: "setup/titles",
  sectors: "setup/sectors",
};
